import { generateColumnGroup } from './utils';
import { TableSeparatorWrapper } from './styled';

interface THeadProps {
  key: string;
  value: string;
}

const THead = ({ key, value }: THeadProps) => (
  <th key={key} className="orderbook-text-cell title">
    {value}
  </th>
);

const TableSeparator = () => (
  <TableSeparatorWrapper>
    {generateColumnGroup()}

    <thead>
      <tr key="header">
        <THead key="bid-frequency-title" value="Freq" />
        <THead key="bid-lot-title" value="Lot" />
        <THead key="bid-price-title" value="Bid" />
        <THead key="offer-price-title" value="Offer" />
        <THead key="offer-lot-title" value="Lot" />
        <THead key="offer-frequency-title" value="Freq" />
      </tr>
    </thead>
  </TableSeparatorWrapper>
);

export default TableSeparator;
